import { render, staticRenderFns } from "./BathroomCreation.vue?vue&type=template&id=3ebd997a&scoped=true"
import script from "./BathroomCreation.vue?vue&type=script&lang=js"
export * from "./BathroomCreation.vue?vue&type=script&lang=js"
import style0 from "./BathroomCreation.vue?vue&type=style&index=0&id=3ebd997a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd997a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebd997a')) {
      api.createRecord('3ebd997a', component.options)
    } else {
      api.reload('3ebd997a', component.options)
    }
    module.hot.accept("./BathroomCreation.vue?vue&type=template&id=3ebd997a&scoped=true", function () {
      api.rerender('3ebd997a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/BathroomCreation.vue"
export default component.exports